<template>
  <VDialog
    :open="isOpen"
    :headline="heading"
    modal
    @close="$emit('cancel')"
    style="--dialog-min-inline-size: 400px;"
  >
    <template #body>
      <p class="warning-description">{{ description }}</p>
    </template>
    <template #action-items>
      <VButton class="vvd-btn-cancel" appearance="filled" :label="cancelText" @click="$emit('cancel')" />
      <VButton class="vvd-btn-primary" connotation="cta" appearance="filled" :label="confirmText" @click="$emit('confirm')" />
    </template>
  </VDialog>
</template>

<script>
export default {
  name: "CustomWarningModal",
  props: {
    isOpen: { type: Boolean, required: true },
    heading: { type: String, default: "Are you sure?" },
    description: {
      type: String,
      default: "This action cannot be undone. Please confirm if you want to proceed.",
    },
    confirmText: { type: String, default: "Yes, continue" },
    cancelText: { type: String, default: "Cancel" },
  },
  emits: ["confirm", "cancel"],
};
</script>

<style scoped>
.warning-description {
  font-size: 14px;
  color: var(--black);
  margin: 0;
  line-height: 1.5;
}
</style>
